import React from 'react';
import translate from '../Translate.js';
import * as icons from '../Icons/Icons';

class MFAChallenge extends React.Component {
  constructor() {
    super();
    this.state = {
      code: '',
      verifying: false,
      error: null
    };
    this.handleCodeInput = this.handleCodeInput.bind(this);
    this.verifyCode = this.verifyCode.bind(this);
  }

  componentDidMount() {
    const tempToken = sessionStorage.getItem('mfaTempToken');
    
    if (!tempToken) {
      this.props.routing.push('/account/sign-in');
    }
  }

  handleCodeInput(e) {
    const value = e.target.value.replace(/\D/g, '').slice(0, 6);
    this.setState({ code: value, error: null });
  }

  verifyCode(e) {
    e.preventDefault();
    
    if (this.state.code.length !== 6) {
      this.setState({ error: 'Please enter a 6-digit code' });
      return;
    }

    const tempToken = sessionStorage.getItem('mfaTempToken');
    const installSid = sessionStorage.getItem('mfaInstallSid');

    this.setState({ verifying: true, error: null });

    this.props.store.SessionStore.verifyMFAChallenge(tempToken, installSid, this.state.code, (error) => {
      if (error) {
        this.setState({ 
          error: 'Invalid code. Please try again.', 
          verifying: false,
          code: ''
        });
      } else {
        sessionStorage.removeItem('mfaTempToken');
        sessionStorage.removeItem('mfaInstallSid');
        this.props.routing.push('/');
      }
    });
  }

  render() {
    const { code, verifying, error } = this.state;
    const backgroundImg = 'url(./static/img/bg-sign-up.jpg)';

    return (
      <main className="page page--graphic page--pane-right" style={{backgroundImage: backgroundImg}}>
        <div className="page--graphic__content wrap">
          <img src="./static/img/logo-white.png" width="300" alt="SmarterProctoring" />
        </div>
        <div className="pane pane--right pane--fixed">
          <div className="pane__content">
            <div style={{ textAlign: 'center', marginBottom: '20px' }}>
              <i className="page--error__icon" style={{ color: '#2196F3' }}>
                <icons.iconLock />
              </i>
            </div>
            
            <h1 className="pane__title">Multi-Factor Authentication</h1>
            
            <p className="meta" style={{ marginBottom: '30px', textAlign: 'center' }}>
              Enter the verification code from your authenticator app to continue
            </p>

            <form onSubmit={this.verifyCode} noValidate>
              <fieldset>
                <ul className="fields">
                  <li>
                    <label className="meta" htmlFor="mfa-code">Verification Code</label>
                    <input 
                      type="text" 
                      id="mfa-code" 
                      placeholder="000000"
                      value={code}
                      onChange={this.handleCodeInput}
                      maxLength="6"
                      pattern="[0-9]*"
                      inputMode="numeric"
                      required 
                      aria-required="true"
                      autoFocus
                      disabled={verifying}
                      style={{ textAlign: 'center', fontSize: '18px', letterSpacing: '4px' }}
                    />
                  </li>
                </ul>
              </fieldset>

              {error && (
                <div className="notice notice--error" style={{ marginBottom: '15px' }}>
                  <p>{error}</p>
                </div>
              )}

              <button className="btn" type="submit" disabled={verifying || code.length !== 6}>
                {verifying ? 'Verifying...' : 'Verify & Sign In'}
              </button>
            </form>

            <div style={{ marginTop: '20px', padding: '15px 20px', background: '#fff3cd', borderLeft: '4px solid #ffc107', borderRadius: '4px' }}>
              <p style={{ fontSize: '14px', margin: 0, color: '#664d03', lineHeight: '1.6', fontWeight: '400' }}>
                <strong style={{ fontWeight: '600' }}>Need help?</strong> Lost your device? Contact your administrator for assistance.
              </p>
            </div>
          </div>
        </div>
      </main>
    );
  }
}

export default translate('MFAChallenge')(MFAChallenge);



// WEBPACK FOOTER //
// ./src/app/components/Account/MFAChallenge.js